const ACIP_STATES = [
  "AL",
  "AZ",
  "CA",
  "GA",
  "HI",
  "IN",
  "IA",
  "KY",
  "LA",
  "ME",
  "MI",
  "MN",
  "MT",
  "NH",
  "NM",
  "NY",
  "NC",
  "ND",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "UT",
  "VT",
  "WI",
  "WY"
];

export const isAcipState = (state: string) => ACIP_STATES.includes(state);
